$.fn.GridSizer = function() {
  let self = $(this).BlockElement()

  if (self.data('grid-sizer')) {
    return self.data('grid-sizer')
  }

  self.card_selector = '.card-home'
  self.image_selector = '.card-home__image'

  self.do_resize = function() {
    self.css('width', '')
    self.css('width', Math.floor(self.outerWidth(false)) + 'px')
    self.find('.grid__item > ' + self.card_selector).each(function() {
      $(this).css('width', '')
      $(this).css('width', Math.floor($(this).outerWidth(false)) + 'px')
      let image = $(this).find(self.image_selector)
      if (image.length) {
        image.css({
          'padding-top': '',
          'height': '',
          'margin-left': '',
        })
        image.css({
          'padding-top': 0,
          'height': Math.floor($(this).find('.picture').outerHeight(false)) + 'px',
          'margin-left': '-' + (image.offset().left % 1) + 'px',
        })
      }
    })
  }

  return function() {
    if (self.find('.card-culture__image').length) {
      self.card_selector = '.card-culture'
      self.image_selector = '.card-culture__image'
    } else if (self.find('.card-director__image').length) {
      self.card_selector = '.card-director'
      self.image_selector = '.card-director__image'
    }
    $(window).on('load orientationchange resize', self.do_resize)
    self.do_resize()
    self.data('grid-sizer', self)
    return self
  }()
}
